import { env } from '@/infra/env'
import { createRemoteJWKSet, jwtVerify } from 'jose'

let jwks: ReturnType<typeof createRemoteJWKSet> | undefined

function getJwks() {
  jwks ??= createRemoteJWKSet(
    new URL(`https://${env.AUTH0_DOMAIN}/.well-known/jwks.json`),
  )
  return jwks
}

/**
 * Returns true only for a validly-signed, unexpired Auth0 id_token minted for
 * our client.
 */
export async function verifyAuth0IdToken(token: string): Promise<boolean> {
  try {
    await jwtVerify(token, getJwks(), {
      issuer: `https://${env.AUTH0_DOMAIN}/`,
      audience: env.AUTH0_CLIENT_ID,
    })
    return true
  } catch {
    return false
  }
}
